import React, { useContext, useReducer, useEffect } from 'react';
import { Box, Tooltip, TextField } from '@mui/material'
import MegaAutoComplete from '../../Utils/megautocomplete';
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import { lockedReducer } from '../../Utils/reducers';
import { externalComponent } from '../../AppRoutes';
import validateData from './validateData';
import { api } from '../../../services/api';
import toast from 'react-hot-toast';
import { PercentFormatInputDefault } from '../../Utils/PercentInputDefault';
import { NumericFormat } from 'react-number-format';
import { NumericFormatInput } from '../../Utils/NumericInput';

const url = 'desconto_volume'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (setLoader, data, getData, handleClose) => {

    setLoader(true)
    let res = ''
    if (data.id !== 0 && data.id !== undefined) {
        res = await api.patch(url + `/${data.id}/`, data)
    } else {
        res = await api.post(url, data)
    }

    if (res.status === 200 || res.status === 201) {
        toast.success(`Cliente ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Cliente não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const EditDescontoVolume = ({ data, handleClose, reloadData }) => {

    const [state, setState] = useReducer(lockedReducer, {
        editRow: null,
        client: "",
        discount: "",
        monthlyvolume: "",
        ...data,
        id: data.id ? data.id : 0
    })

    const { setLoader } = useContext(externalComponent)
    const validTable = validateData(state)

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "sm" }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} Desconto de volume`}
                content={

                    <Box className='item-content-modal noborder'>

                        <Box className='item-profile-row'>
                            <MegaAutoComplete
                                id="desconsideradosClientes"
                                multiple={false}
                                value={state.client}
                                onChange={(data) => { setState({ client: data }) }}
                                noOptionsText={'Digite para procurar um cliente'}
                                timeoutUrl='/frete/clientes_empresas/'
                                timeoutParam='label'
                                label='Clientes'
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                            id="desconto"
                            type="text"
                            label="Desconto"
                            value={state.discount}
                            onChange={(e) => { setState({ 'discount': e.target.value }) }}
                            fullWidth={false}
                            size='small'
                            inputProps={{
                                maxLength: 50
                            }}
                            InputProps={{
                                inputComponent: PercentFormatInputDefault,
                            }}
                            sx={{width:'100%'}}
                        />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                            id="volume"
                            type="text"
                            label="Desconto de volume"
                            value={state.monthlyvolume}
                            onChange={(e) => { setState({ 'monthlyvolume': e.target.value }) }}
                            fullWidth={false}
                            size='small'
                            inputProps={{
                                maxLength: 50
                            }}
                            InputProps={{
                                inputComponent: NumericFormatInput,
                            }}
                            sx={{width:'100%'}}
                        />
                        </Box>

                    </Box>

                }

                action={
                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(setLoader, state, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>
                }
            />

        </>
    )
}

export default EditDescontoVolume;